import { RefObject } from 'react';
import { ToastProps, Typography, useToaster, useTranslate } from '@prenuvo/halo';

import { ErrorWithoutBackground } from '@/assets/icons';

interface ToastHandlerArgs extends Omit<ToastProps, 'description'> {
  description: string;
  toastRef: RefObject<HTMLSpanElement | null>;
}

export function useToastHandler({
  className,
  description,
  title,
  toastRef,
  variant = 'error',
}: ToastHandlerArgs) {
  const { addToast } = useToaster();
  const translate = useTranslate();

  return () => {
    if (toastRef.current) {
      return;
    }

    addToast({
      className,
      description: (
        <span className="flex flex-row gap-4 p-1" ref={toastRef}>
          <img
            alt={translate('FCT.ACCESSIBILITY.ALT_TEXT.MISSING_INPUT')}
            src={ErrorWithoutBackground}
          />
          <Typography
            as="span"
            className="text-red-500 dark:text-red-500"
            translationKey={description}
          />
        </span>
      ),
      duration: 3000,
      title,
      variant,
    });
  };
}
